import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PlannerAccountApplicationButton
  from 'Components/AdvisorApp/Viewport/ApexAdminPortal/OpenAccountButtonPicker/PlannerAccountApplicationButton/PlannerAccountApplicationButton';

const styles = () => ({
  root: {},
});

const PlannerAccountApplicationButtonContainer = ({
  ...rest
}) => {
  return (
    <PlannerAccountApplicationButton {...rest} />
  );
};

PlannerAccountApplicationButtonContainer.defaultProps = {
};

PlannerAccountApplicationButtonContainer.propTypes = {
};

export default withStyles(styles)(PlannerAccountApplicationButtonContainer);
